import addAPlanService from "../../services/AddAPlan";
import { AddAPlanValidationStatus } from "../../constants/Constants";
export const ADD_NEW_POLICY = "ADD_NEW_POLICY";

export function addAPlan(membershipNumber) {
  return (dispatch) =>
    addAPlanService(membershipNumber).then((data) => {
      if (data && data.message === AddAPlanValidationStatus.AddPlanSuccess) {
        dispatch({
          type: ADD_NEW_POLICY,
          payload: {
            policy: data.policy,
            index: data.index
          }
        });
      }
      return data;
    });
}
